<template>
    <div class="studentListTable">
        <table>
            <tbody>
            <tr class="title">
                <th>咨询类别</th>
                <!-- <th>咨询数</th> -->
                <th>时间</th>
                <th>主题</th>
                <th>操作</th>
            </tr>
            <tr  v-for="(value,index) in list" :key="index" >
                <td class="type">
                    <span :class="circleType(value.category)"></span>
                    {{value.categoryName}}
                </td>
                <!-- <td>第{{value.interviewNum}}次咨询</td> -->
                <td>{{value.interviewTime}}</td>
                <td>
                    <p>{{value.interviewTheme}}</p>
                </td>
                <td>
                    <span class="btn goView" @click="goDetail(value.category,value.id,value.interviewTheme,value.studentId)"
                    >查看</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    name: "studentListTable",
    props: ['list','userType','studentId'],
    components: {
    },
    data() {
        return {
        }
    },
    computed: {
    },

    methods: {
        circleType(category) {
            // 类别：1首次访谈 2规划内容 3 目标拆分 4行动计划 5自由主
            switch(category) {
                case 1:
                    return 'circle1'
                    break;
                case 2:
                    return 'circle2'
                    break;
                case 3:
                    return 'circle3'
                    break;
                case 4:
                    return 'circle4'
                    break;
                case 5:
                    return 'circle5'
                    break;
            }

        },
        goDetail(category,id,interviewTheme,studentId) {
            if(this.userType==3) {
                if(category==5){
                    this.$router.push({path:'/consultant/minestudent/main/consultationRecord/student/detail',query:{id: id}})
                    return;
                }
                if(category==1){
                    this.$router.push({path:'/consultant/newstudent/main/firstInterviewPartA',query:{studentId: this.studentId,show:'已完成'}})
                    return;
                }
                this.getInterviewFreeThemeDetail(category,id,interviewTheme);
            }else if(this.userType==2) {
                if(category==5){
                    this.$router.push({path:'/parent/main/consultationRecord/student/detail',query:{id: id}})
                    return;
                }
                if(category==1){
                    this.$router.push({path:'/parent/main/studentMessage/part_A',query:{studentId: studentId,show:'已完成'}})
                    return;
                }
                this.getInterviewFreeThemeDetailByParent(category,id,interviewTheme);
            }else if(this.userType==1) {
                if(category==5){
                    this.$router.push({path:'/studyPlan/consultationRecord/student/detail',query:{id: id}})
                    return;
                }
                if(category==1){
                    this.$router.push({path:'/studyPlan/studentMessage/part_A',query:{studentId: studentId,show:'已完成'}})
                    return;
                }
                this.getInterviewFreeThemeDetailByStudent(category,id,interviewTheme);
            }
        },
        // 咨询师获取id
        getInterviewFreeThemeDetail(category,id,interviewTheme){
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.consultationRecord.getInterviewFreeThemeDetail, {
                id:id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data=res.data;
                if(data.code===2000){
                    if(category==2) {
                        if(!data.data.lastId){
                            this.$router.push({path:'/consultant/minestudent/main/planningContent/planningReport',query:{id: data.data.id}})
                        }else {
                            this.$router.push({path:'/consultant/minestudent/main/planningContent/adjustmentReport',query:{id: data.data.id,lastId:data.data.lastId}})
                        }
                    }
                    if(category==3) {
                        this.$router.push({path:'/consultant/minestudent/main/implement/targetsplit/show',query:{targetId: data.data.id}})
                    }
                    if(category==4) {
                        if(data.data.type==1){
                            // 行动计划
                            this.$router.push({path:'/consultant/minestudent/main/implement/actionplan/show',query:{actionPlanId: data.data.id, gradeDetailId: data.data.studentTestScoreId}})
                        } else if(data.data.type==2) {
                            // 行动计划评估
                            this.$router.push({path:'/consultant/minestudent/main/implement/actionplan/assessmentShow',query:{actionPlanId: data.data.id, gradeDetailId: data.data.studentTestScoreId}})
                        } else {
                            // 阶段评估
                            this.$router.push({path:'/consultant/minestudent/main/implement/assessment/show',query:{assessmentId: data.data.id}})
                        }
                    }
                }
            })
        },
        // 家长获取
        getInterviewFreeThemeDetailByParent(category,id,interviewTheme){
            this.$ajax.post(this.G_acapi + this.ports.parent.student.consultationRecord.getInterviewFreeThemeDetailByParent, {
                id:id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data=res.data;
                if(data.code===2000){
                    if(category==2) {
                        if(!data.data.lastId){
                            this.$router.push({path:'/parent/main/planningContent/planningReport',query:{id: data.data.id}})
                        }else {
                            this.$router.push({path:'/parent/main/planningContent/adjustmentReport',query:{id: data.data.id,lastId:data.data.lastId}})
                        }
                    }
                    if(category==3) {
                        this.$router.push({path:'/parent/main/implement/targetsplit/show',query:{targetId: data.data.id}})
                    }
                    if(category==4) {
                        if(data.data.type==1){
                            this.$router.push({path:'/parent/main/implement/actionplan/show',query:{actionPlanId: data.data.id, gradeDetailId: data.data.studentTestScoreId}})
                        } else if(data.data.type==2) {
                            this.$router.push({path:'/parent/main/implement/actionplan/assessmentShow',query:{actionPlanId: data.data.id, gradeDetailId: data.data.studentTestScoreId}})
                        } else {
                            this.$router.push({path:'/parent/main/implement/assessment/show',query:{assessmentId: data.data.id}})
                        }
                    }
                }
            })
        },
        // 学生获取
        getInterviewFreeThemeDetailByStudent(category,id,interviewTheme){
            this.$ajax.post(this.G_acapi + this.ports.student.student.consultationRecord.getInterviewFreeThemeDetailByStudent, {
                id:id
            }, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data=res.data;
                if(data.code===2000){

                    if(category==2) {
                        if(!data.data.lastId){
                            this.$router.push({path:'/studyPlan/planningContent/planningReport',query:{id: data.data.id}})
                        }else {
                            this.$router.push({path:'/studyPlan/planningContent/adjustmentReport',query:{id: data.data.id,lastId:data.data.lastId}})
                        }
                    }
                    if(category==3) {
                        this.$router.push({path:'/studyPlan/implement/targetsplit/show',query:{targetId: data.data.id}})
                    }
                    if(category==4) {
                        if(data.data.type==1){
                            this.$router.push({path:'/studyPlan/implement/actionplan/show',query:{actionPlanId: data.data.id, gradeDetailId: data.data.studentTestScoreId}})
                        } else if(data.data.type==2) {
                            this.$router.push({path:'/studyPlan/implement/actionplan/assessmentShow',query:{actionPlanId: data.data.id, gradeDetailId: data.data.studentTestScoreId}})
                        } else {
                            this.$router.push({path:'/studyPlan/implement/assessment/show',query:{assessmentId: data.data.id}})
                        }
                    }
                }
            })
        },
    }

}
</script>

<style scoped lang="less">
.studentListTable {
    table {
        width: 100%;
        th {
            text-align: center;
        }
        tr.title {
            background: rgba(61, 144, 246, 0.2);
            border-radius: 5px;
            font-size: 16px;
            font-weight: bold;
            color: #333;
        }
        tr {
            line-height: 40px;
            text-align: center;
            border-bottom: 1px solid #ECECEC !important;
            .goView {
                color: #0095EB;
                cursor: pointer;
            }
            th {
                font-weight: bold;
            }
        }
        .type {
            display: flex;
            align-items: center;
            justify-content: center;
            span {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                margin-right: 5px;
            }
            //1首次访谈 2规划内容 3 目标拆分 4行动计划 5自由主题
            .circle1 {
                background-color: #FFCD57;
            }
            .circle2 {
                background-color: #A3CF76;
            }
            .circle3 {
                background-color: #5DC2D0;
            }
            .circle4 {
                background-color: #E23D7F;
            }
            .circle5 {
                background-color: #0095EB;
            }
        }
    }
}
</style>